import React from "react";
import {Button, Row, Spinner} from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import {nextStep} from "../../actions/actionCreators";
import { connect } from 'react-redux';
import i18n from "../../i18nextInitiator";

const t = i18n.getFixedT('fa','location');
const mapStateToProps = state => ({ ...state.order });
const mapDispatchToProps = dispatch => ({});

const ContinueButton = (props) => {
    return(
        <Row style={{display: "flex", justifyContent: "center", padding: "0 15px"}}>

            {/*{!props.noBack && <StepBackButton lastStep={props.lastStep}/>}*/}

            <Button style={{position: "fixed"}}
                    disabled={props.isSelectingLocation}
                    onClick={props.clicker ?? nextStep}
                    className='continue-btn col-11 col-md-6 float-left'
                    size={'lg'}>

                    {props.showPrice &&
                    ( (props.price && props.price !== 0) ?
                        <span className='btn-price'>
                            {
                                props.inProgress ? <Spinner animation="border" variant="light" /> :
                                <h3>{ props.price === 'NaN' ?  'خطادربرقراری‌ارتباط' : props.price + " تومان " }</h3>
                            }
                        </span> : null
                    )
                    }

                <span className='btn-price'>
                    {props.inProgress ? <Spinner animation="border" variant="light" /> :
                        <h3>
                            {props.submitText ??
                            <>
                                {props.text ?? t('next')}
                                {/*{props.text ? '': <img alt='next' src={`${process.env.PUBLIC_URL}/orders/images/arrow-left.svg`}/>}*/}
                            </>
                            }
                        </h3>
                    }

                </span>
            </Button>

        </Row>
    );

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContinueButton));